import React from "react";
import { withRouter, useLocation } from "react-router-dom";


import URL from "../../../../constant/URL";
import http from "../../../../http/http";
import useLoading from "../../../../hooks/useLoading";
import { useLearningBtn, useUserInfo } from "../../../../hooks";
import XbtnTitleHeader from "../../../common/header/XbtnTitleHeader";
import { PROP, TYPE } from "../../../../constant";
import { getUserAgent } from "../../../../utils/utilityEtc";

const AiPrediction = withRouter((props) => {
  const location = useLocation();
  const { info } = useUserInfo();

  const { setLoading, clearLoading } = useLoading();
  const [, goAiLearning] = useLearningBtn();
  const [resultData, setResultData] = React.useState({});
  const [startFlag, setStartFlag] = React.useState(true);

  const close = () => {
    props.history.goBack();
  };

  // const moveBack = () => {
  //   props.history.replace({ pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA });
  // };

  const moveNext = () => {
    goAiLearning(resultData);
  };

  const getAiPredictionResult = () => {
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    const { state } = location;
    const { channelCode, learnerId, locale, learnerBirth } = info;
    let aiDiagnosisTestData = {
      grade: '',
      sxdnCd: ''
    };

    if (state?.aiDiagnosisTestData) {
      const { grade, sxdnCd } = state.aiDiagnosisTestData;
      aiDiagnosisTestData = { grade, sxdnCd }
    }

    http.request({
      url: `${URL.API.DIAGNOSIS.PROPOSAL}`,
      method: http.METHOD.POST,
      data: {
        chnCd: channelCode,
        lrnMbrId: learnerId,
        brthmt: learnerBirth,
        langCd: locale,
        grade: channelCode === TYPE.CHANNEL.GM ? aiDiagnosisTestData.grade : '',
        sxdnCd: channelCode === TYPE.CHANNEL.GM ? aiDiagnosisTestData.sxdnCd : '',
        timeZone: getUserAgent('timeZone'),
        nationCd: getUserAgent('countryCode')

      },
      success: (res) => {
        if (res?.qstCd) {
          setStartFlag(false);
        }
        clearLoading();

        setResultData(res);
      },
      error: () => {
        clearLoading();
      }
    });
  };

  React.useEffect(() => {
    getAiPredictionResult();
  }, []);

  return (

    <div className="layout-def layout-lc theme-sky gb">
      <XbtnTitleHeader
        title="AI 진단테스트"
        onClose={close}
      />
      <div className="container">
        <div className="inner">
          <div className="d-flex full f-middle">
            <div className="d-item w100p">
              <div className="aic-predicBox">
                <div className="txtNoti">AI가 예측한 문제 수와 시간입니다.</div>
                <div className="txtBox">
                  <em>문제 수</em>
                  <span className="txt">{resultData?.aiPrdcnQstCt ? `${resultData.aiPrdcnQstCt} 문제 이하` : '0 문제'}</span>
                </div>
                <div className="txtBox last" >
                  <em>예상 시간</em>
                  <span className="txt">{resultData?.estDiagDur ? `약 ${resultData.estDiagDur}분` : '0 분'}</span>
                </div>
                <div className="txtNoti last">진단 테스트를 시작하시겠습니까?</div>
                <div className="predic_btn_wrap">
                  <button className="btn btn-white" onClick={moveNext} disabled={startFlag}>시작하기</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

});

export default AiPrediction;
